import React, { Component } from "react";
import TabBorderItem from "./items/border";
import LachakToranjTabCornerItem from "./items/corner";
import LachakToranjTabToranjItem from "./items/toranj";
import LachakToranjTabBackgroundItem from "./items/lachakToranjBackground";

export default class LachakToranjTabItems extends Component {
  render() {
    return (
      <ul className="ul-background-select">
        <TabBorderItem
          texts={this.props.texts}
          activePartsTab={this.props.activePartsTab}
          partsTabHandler={this.props.partsTabHandler}
        />
        <LachakToranjTabCornerItem
          texts={this.props.texts}
          activePartsTab={this.props.activePartsTab}
          partsTabHandler={this.props.partsTabHandler}
        />
        <LachakToranjTabBackgroundItem
          texts={this.props.texts}
          activePartsTab={this.props.activePartsTab}
          partsTabHandler={this.props.partsTabHandler}
        />
        <LachakToranjTabToranjItem
          texts={this.props.texts}
          activePartsTab={this.props.activePartsTab}
          partsTabHandler={this.props.partsTabHandler}
        />
      </ul>
    );
  }
}
